import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

import { useHostedScrapingProjects } from "providers/HostedScrapingProvider";
import { NewProjectEditProject } from './NewProjectEditProject';
import { ProjectNotFound } from "components/hosted-scraping/ProjectNotFound";
import { FullWidthLoadingSpinner } from "components/FullWidthLoadingSpinner";

export default function ProjectEditPage() {
  const navigate = useNavigate();
  const { projectId: projectIdParam} = useParams() as { projectId: string};
  const { currentProject, currentProjectLoading, fetchCurrentProject, clearCurrentProject } = useHostedScrapingProjects();

  const projectId = parseInt(projectIdParam);

  useEffect(() => {
    fetchCurrentProject(projectId);
    return () => { clearCurrentProject(); };
  }, [ projectId, fetchCurrentProject, clearCurrentProject ]);

  if (currentProjectLoading && !currentProject) {
    return (<FullWidthLoadingSpinner />);
  }

  if (!currentProject) {
    return (<ProjectNotFound/>);
  }

  return (
    <NewProjectEditProject mode='editProject' project={currentProject} cancelButtonVisible backCallback={async () => {
      await fetchCurrentProject(projectId);
      navigate(`/projects/${projectId}`);
    }}/>
  )
}
